import { render } from "./afterSales.vue?vue&type=template&id=d6fd42e0&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=d6fd42e0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6fd42e0"]])

export default __exports__